import * as yup from 'yup';

export const schema = yup.object().shape({
  prompt: yup.string().required('Prompt is a required field'),
  ratio: yup.string().required('One of Ratio variants must be selected'),
  style: yup.string().required('One of Style variants must be selected'),
  magic: yup.boolean(),
  // INJECT
});
